import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { getNumberOfItemsInCart } from "@app/modules/data-exchange/store/data-exchange.selectors";
import { Store } from "@ngrx/store";

@Component({
    selector: "app-shopping-cart-page",
    templateUrl: "./shopping-cart-page.component.html",
    styleUrls: ["./shopping-cart-page.component.scss"],
    standalone: false
})
export class ShoppingCartPageComponent {
  numberOfItems$ = this.store.select(getNumberOfItemsInCart);
  alertMessage =
    "Your subscription shall auto-renew in accordance with the subscription term option selected. Please see the Terms of Data Exchange for Broker Subscription Services for more information.";

  constructor(
    private router: Router,
    private store: Store,
  ) {}

  proccedToCheckout(): void {
    this.router.navigate(["/shopping-cart/checkout"]);
  }
}
